const paymentMethodLabelStrings = {
  multiplePaymentMethods: "Flere betalingsmåter"
};

export default paymentMethodLabelStrings;